import { useCallback, useContext, useState } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useChatSupport } from "@hopper-b2b/self-serve";
import {
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import clsx from "clsx";
import { UserContext } from "../../../App";
import Headset from "../../../assets/client/headset.svg?react";
import { ContactSupportModalContent } from "../ContactSupportModalContent";
import styles from "./ContactSupportAction.module.scss";

export const ContactSupportAction = () => {
  const { t } = useI18nContext();

  const { sessionInfo } = useContext(UserContext);
  const { generalSupportChat } = useChatSupport();
  const [openContactSupportModal, setOpenContactSupportModal] = useState(false);

  const handleOpenContactSupportModal = useCallback(
    () => setOpenContactSupportModal(true),
    []
  );

  const handleCloseContactSupportModal = useCallback(
    () => setOpenContactSupportModal(false),
    []
  );

  const handleOpenChat = useCallback(() => {
    handleCloseContactSupportModal();
    generalSupportChat();
  }, [generalSupportChat, handleCloseContactSupportModal]);

  const handleContactSupportClick = useCallback(
    () => handleOpenContactSupportModal(),
    [handleOpenContactSupportModal]
  );

  // Check if support access is restricted
  const portalAccess = sessionInfo?.userInfoResponse?.portalAccess;
  const isSupportRestricted = portalAccess?.support === false;

  // If support is restricted, don't render the button
  if (isSupportRestricted) {
    return null;
  }

  return (
    <>
      <button
        className={styles.contactSupportButton}
        onClick={handleContactSupportClick}
      >
        <Headset className="mobile-action-link-icon help" />
        {t("contactSupport")}
      </button>
      <MobilePopoverCard
        open={openContactSupportModal}
        className="contact-support-modal"
        scroll="paper"
        fullScreen
        topRightButton={
          <ActionLink
            className="introduction-modal-close-button"
            data-cy="contact-support-modal-close"
            content={
              <IconComponent
                ariaLabel={t("modalClose.ariaLabel")}
                className={clsx("close-button-icon")}
                name={IconName.Close}
              />
            }
            label={t("modalClose.label")}
            onClick={handleCloseContactSupportModal}
          />
        }
        onClose={handleCloseContactSupportModal}
      >
        <ContactSupportModalContent
          onClose={handleCloseContactSupportModal}
          onContactSupport={handleOpenChat}
        />
      </MobilePopoverCard>
    </>
  );
};
